var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationsoff(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_54_872",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#808080"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_54_872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.5C2.5 10.4167 2.96354 8.50521 3.89063 6.76563C4.81771 5.02604 6.0625 3.58333 7.625 2.4375L9.09375 4.4375C7.84375 5.35417 6.84896 6.51042 6.10938 7.90625C5.36979 9.30208 5 10.8333 5 12.5H2.5ZM25 12.5C25 10.8333 24.6302 9.30208 23.8906 7.90625C23.151 6.51042 22.1562 5.35417 20.9062 4.4375L22.375 2.4375C23.9375 3.58333 25.1823 5.02604 26.1094 6.76563C27.0365 8.50521 27.5 10.4167 27.5 12.5H25ZM5 23.75V21.25H7.5V12.5C7.5 10.7708 8.02083 9.23438 9.0625 7.89062C10.1042 6.54688 11.4583 5.66667 13.125 5.25V4.375C13.125 3.85417 13.3073 3.41146 13.6719 3.04688C14.0365 2.68229 14.4792 2.5 15 2.5C15.5208 2.5 15.9635 2.68229 16.3281 3.04688C16.6927 3.41146 16.875 3.85417 16.875 4.375V5.25C18.5417 5.66667 19.8958 6.54688 20.9375 7.89062C21.9792 9.23438 22.5 10.7708 22.5 12.5V21.25H25V23.75H5ZM15 27.5C14.3125 27.5 13.724 27.2552 13.2344 26.7656C12.7448 26.276 12.5 25.6875 12.5 25H17.5C17.5 25.6875 17.2552 26.276 16.7656 26.7656C16.276 27.2552 15.6875 27.5 15 27.5ZM10 21.25H20V12.5C20 11.125 19.5104 9.94792 18.5312 8.96875C17.5521 7.98958 16.375 7.5 15 7.5C13.625 7.5 12.4479 7.98958 11.4688 8.96875C10.4896 9.94792 10 11.125 10 12.5V21.25Z",
    fill: "#111723"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsoff);
export default __webpack_public_path__ + "static/media/notificationsoff.729de301c6f352f2f5f9bcca57e958b0.svg";
export { ForwardRef as ReactComponent };